// src/pages/ContactUsPage.tsx
import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card'; // Adjust path
import { Input } from '../components/ui/input'; // Adjust path
import { Textarea } from '../components/ui/textarea'; // Adjust path
import { Button } from '../components/ui/Button'; // Adjust path

const ContactUsPage = () => {
  return (
    <div className="page-container">
      <h2 className="page-title">Contact Us</h2>

      <div className="contact-grid">
        <div className="contact-info-section">
          <h3 className="section-subtitle">Get in Touch</h3>
          <p className="section-text">
            We're here to answer your questions and help you with your HVAC needs. Please feel free to
            contact us using the information below or by filling out the contact form.
          </p>
          <ul className="contact-list">
            <li className="contact-item">
              <MapPin className="icon-inline" />
              <span className="contact-text">10 Dansk Court (Unit 13-14), Etobicoke, ON M9W 5T8</span>
            </li>
            <li className="contact-item">
              <Phone className="icon-inline" />
              <span className="contact-text">+1 (416) 674-0331</span>
            </li>
            <li className="contact-item">
              <Mail className="icon-inline" />
              <span className="contact-text">info@venushvacsupply.com</span>
            </li>
          </ul>
        </div>

        <div className="contact-form-section">
          <h3 className="section-subtitle">Contact Form</h3>
          <Card className="contact-form-card">
            <CardContent className="contact-form-content">
              <Input placeholder="Your Name" className="form-input" />
              <Input placeholder="Your Email" className="form-input" />
              <Input placeholder="Subject" className="form-input" />
              <Textarea placeholder="Your Message" className="form-textarea" />
              <Button className="contact-form-submit-button">
                <Mail className="icon" />
                Send Message
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
